/**
 * FlowHub - useN8nWorkflows Hook
 * TanStack Query hooks for fetching workflows from N8N instances
 */

import { useQuery } from '@tanstack/react-query';
import { functions } from '../../../shared/lib/supabase';

interface Workflow {
  id: string;
  name: string;
  folderId?: string;
  folderName?: string;
  [key: string]: any;
}

/**
 * Hook to fetch workflows from a specific N8N instance
 * Filters by the specified tag (default: 'Template')
 */
export function useN8nWorkflows(n8nInstanceId: string | undefined, tagFilter: string = 'Template') {
  return useQuery({
    queryKey: ['n8n-workflows', n8nInstanceId, tagFilter],
    queryFn: async () => {
      if (!n8nInstanceId) return [];
      try {
  const result = await functions.listWorkflows(n8nInstanceId, tagFilter);
        console.log('DEBUG n8n workflows result:', result);
        
        const allWorkflows = result?.workflows || [];
        
        // Filter workflows by specified tag
        const filteredWorkflows = allWorkflows.filter((workflow: Workflow) => {
          const tags = Array.isArray(workflow.tags) ? workflow.tags : [];
          return tags.some((tag: any) => {
            const tagName = typeof tag === 'string' ? tag : tag.name;
            return tagName?.toLowerCase() === tagFilter.toLowerCase();
          });
        });
        
        console.log(
          `Filtered ${allWorkflows.length} workflows to ${filteredWorkflows.length} with '${tagFilter}' tag`
        );
        
        // If no workflows found with tag, log the structure for debugging
        if (filteredWorkflows.length === 0 && allWorkflows.length > 0) {
          console.log(`No workflows found with ${tagFilter} tag. Sample workflow structure:`, {
            name: allWorkflows[0].name,
            id: allWorkflows[0].id,
            tags: allWorkflows[0].tags,
          });
        }
        
        return filteredWorkflows;
      } catch (error) {
        console.error('Error fetching workflows:', error);
        throw error;
      }
    },
    enabled: !!n8nInstanceId,
    staleTime: 5 * 60 * 1000,
  });
}
